function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clip0)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M81.1194 138.754C81.1194 138.754 88.0719 100.901 51.4077 80.6376C14.7434 60.3742 13.0201 60.6119 5.77045 58.2944C1.61081 56.8682 -2.66768 59.8394 2.14562 65.9006C6.95892 71.9618 4.22544 73.5068 13.852 76.1809C23.4786 78.8549 24.9642 90.6208 29.7775 93.5325C34.5908 96.4443 38.8099 97.2168 53.5469 103.575C66.9172 109.339 78.3265 125.621 78.3265 131.385C78.3265 137.149 91.3996 139.051 91.3996 139.051L81.1194 138.754Z",
  fill: "url(#paint0_linear)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M79.812 133.465C79.812 133.465 89.1415 98.6429 57.0529 79.8057C24.9642 60.9684 13.7332 61.2061 7.37486 58.948C3.75003 57.6407 13.7332 62.1569 17.8928 67.7427C22.0525 73.3285 21.0423 72.0806 28.589 76.2403C37.3243 81.0536 40.9491 85.748 46.0595 86.6988C53.4875 88.125 51.2888 95.85 64.1837 101.674C75.8307 106.962 77.3163 121.105 77.3163 126.453C77.3163 131.801 88.7256 133.584 88.7256 133.584L79.812 133.465Z",
  fill: "url(#paint1_linear)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M112.138 128.355L115.763 124.908C117.487 123.304 119.626 122.115 121.943 121.521C133.293 118.55 168.947 107.378 183.744 80.3999C183.863 80.1622 183.744 79.8651 183.506 79.7463H183.447C183.387 79.7463 183.328 79.6868 183.268 79.6868C178.336 79.3303 152.962 78.9143 119.032 107.854C118.437 108.329 117.843 108.923 117.368 109.517C116.536 110.706 115.11 112.726 114.456 113.796C113.565 115.341 115.347 117.956 112.97 120.273C110.593 122.591 105.483 128.355 105.483 128.355L109.643 131.445L112.138 128.355Z",
  fill: "url(#paint2_linear)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M92.8258 126.097C92.8258 126.097 102.571 38.9818 76.009 11.5876C51.5265 -13.608 51.17 9.56717 51.2294 13.4891C51.2294 13.8457 51.3483 14.1428 51.4671 14.4399C57.2312 25.1955 59.2516 37.615 57.1717 49.6186C54.676 62.2163 72.6813 60.5525 74.2263 72.972C75.7713 85.3915 82.0702 104.526 81.4165 113.321C80.7629 122.115 80.7034 130.672 80.7034 130.672L90.5083 130.969L92.8258 126.097Z",
  fill: "url(#paint3_linear)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M92.707 126.394C92.7664 126.215 92.8258 125.978 92.8852 125.799C93.4795 120.095 101.68 38.031 76.009 11.5876C51.7048 -13.4891 51.3482 9.21062 51.4671 13.3108C51.5265 13.7862 51.7642 14.2616 52.0019 14.6776C53.7846 17.2922 61.8068 28.7015 68.9376 27.3942C88.6067 23.8882 71.2551 47.5387 81.9513 60.1959C90.5083 70.1791 87.656 104.645 87.0023 113.499C86.5863 118.49 85.7544 123.363 84.5065 128.236C84.2688 129.484 85.1008 130.672 86.2892 130.91C86.3487 130.91 86.4081 130.91 86.4675 130.91C86.6458 130.91 86.7646 130.969 86.9429 130.969H88.7256C89.7952 131.029 90.746 130.494 91.2214 129.543L92.707 126.394Z",
  fill: "url(#paint4_linear)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M102.274 131.445C102.274 131.445 103.997 107.319 118.081 92.5817C122.003 88.5409 126.994 85.748 132.461 84.5001C136.68 83.5493 143.573 80.1622 149.575 68.8718C149.575 68.8718 160.925 52.8274 172.275 47.9547C183.625 43.082 172.275 42.4877 172.275 42.4877C172.275 42.4877 139.83 48.6678 119.032 67.6833C117.724 68.8718 116.358 70.0008 114.872 70.9516C109.464 74.6358 94.5491 88.5409 95.2028 129.127L102.274 131.445Z",
  fill: "url(#paint5_linear)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M130.441 129.484C130.441 129.484 130.916 126.572 127.054 126.631C123.667 126.75 66.3824 126.334 66.3824 126.334C66.3824 126.334 63.7083 126.334 63.8866 128.355C64.0649 130.375 72.7407 178.092 73.5726 179.102C73.9291 179.696 74.5234 180.172 75.2365 180.35C76.3061 180.647 116.536 180.41 116.536 180.41C117.487 180.291 118.2 179.518 118.259 178.567C118.2 178.627 130.56 130.078 130.441 129.484Z",
  fill: "url(#paint6_linear)"
}));

var _ref3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint0_linear",
  x1: 0.0143985,
  y1: 98.4407,
  x2: 91.3878,
  y2: 98.4407,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#93FD93"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.51,
  stopColor: "#21C2C1"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#84F599"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint1_linear",
  x1: 34.2493,
  y1: 69.6417,
  x2: 86.1736,
  y2: 133.302,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#93FD93"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.51,
  stopColor: "#21C2C1"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#84F599"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint2_linear",
  x1: 94.0644,
  y1: 141.645,
  x2: 165.45,
  y2: 86.411,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#93FD93"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.51,
  stopColor: "#21C2C1"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#84F599"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint3_linear",
  x1: 112.004,
  y1: 113.561,
  x2: 50.6908,
  y2: 35.9423,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#93FD93"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.51,
  stopColor: "#21C2C1"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#84F599"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint4_linear",
  x1: 51.46,
  y1: 65.4673,
  x2: 94.6007,
  y2: 65.4673,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#93FD93"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.51,
  stopColor: "#21C2C1"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#84F599"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint5_linear",
  x1: 90.8747,
  y1: 135.936,
  x2: 137.605,
  y2: 68.3538,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#93FD93"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.51,
  stopColor: "#21C2C1"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#84F599"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint6_linear",
  x1: 63.8781,
  y1: 126.334,
  x2: 137.684,
  y2: 167.567,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#7433FF"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#FFA3FD"
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "clip0"
}, /*#__PURE__*/React.createElement("rect", {
  width: 183.75,
  height: 180.469,
  fill: "white"
})));

function SvgPlant(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 184,
    height: 180,
    viewBox: "0 0 184 180",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlant);
export default __webpack_public_path__ + "static/media/plant.40ac41d7.svg";
export { ForwardRef as ReactComponent };